export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f97d6b1564a0e0f4b2c7e93193eb930c470554960&name=fetchTypeahead!'